import fp from 'lodash/fp';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from '@deerplusofficial/pos-components';
import Cell from './Cell';

const Container = styled.div`
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
`;

class Pagination extends PureComponent {
  static propTypes = {
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    bound: PropTypes.number,
    onPageChange: PropTypes.func,
  };

  static defaultProps = {
    totalPages: 1,
    currentPage: 1,
    bound: 2,
    onPageChange: fp.identity,
  };

  renderCell = index => {
    const { currentPage, onPageChange, bound, totalPages: last } = this.props;
    const page = Number(index + 1);
    const start = 1;
    const insideWindow = Math.abs(this.props.currentPage - page) <= bound;

    if (insideWindow || page === start || page === last)
      return (
        <Cell
          key={page}
          onPageChange={onPageChange}
          page={page}
          active={currentPage === page}
        >
          {page}
        </Cell>
      );

    return fp.inRange(last - 1)(start + 2)(page) ? (
      fp.noop()
    ) : (
      <Cell key={page} disabled>
        ...
      </Cell>
    );
  };

  renderCells = fp.compose(
    fp.map(this.renderCell),
    fp.range(0)
  );

  render() {
    const { totalPages, currentPage, onPageChange } = this.props;

    return (
      <Container>
        {currentPage > 1 && (
          <Cell onPageChange={onPageChange} page={currentPage - 1}>
            <Icon icon="chevron-left" />
          </Cell>
        )}

        {this.renderCells(totalPages)}

        {currentPage < totalPages && (
          <Cell onPageChange={onPageChange} page={currentPage + 1}>
            <Icon icon="chevron-right" />
          </Cell>
        )}
      </Container>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js